import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import importWhiteIcon from '../../../common/Images/import_file_white.png';
import { RELYING_PARTIES_TYPES } from '@silverfort-nodelibs/common/utils/consts';

class ImportRelyingParties extends Component {
    state = {
        loading: false,
        selectedFile: null,
        error: null
    };

    fileChangedHandler = (file) => {
        if (file.size > 1000000) {
            this.setState({ error: 'File exceeds maximum size of 1 MB', loading: false });
        } else {
            this.setState({ selectedFile: file, error: null, loading: false });
        }
    };

    importClickedHandler = () => {
        this.setState({ error: null, loading: true });
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
            const fileContent = e.target.result;
            this.setState({ error: null, loading: false });
            const fileLines = fileContent.split('\n');
            const importedRelyingParties = [];
            for (const relyingPartyLine of fileLines) {
                try {
                    const relyingPartyParts = relyingPartyLine.split('@$@');
                    if (relyingPartyParts.length !== 2) {
                        console.log(`Invalid relying party entry: ${relyingPartyLine}`);
                    } else {
                        const relyingParty = {
                            protocol: RELYING_PARTIES_TYPES.ADFS.DEFAULT_PROTOCOL,
                            name: relyingPartyParts[0]
                                ? relyingPartyParts[0].replace(/\r?\n|\r/g, '')
                                : relyingPartyParts[0]
                        };
                        const identifiersParts = relyingPartyParts[1].split('#$#');
                        if (identifiersParts.length === 0 || !identifiersParts[0]) {
                            console.log(`Invalid relying party entry identifiers: ${relyingPartyLine}`);
                        } else {
                            relyingParty.identifiers = identifiersParts.join(',')
                                ? identifiersParts.join(',').replace(/\r?\n|\r/g, '')
                                : identifiersParts.join(',');
                            importedRelyingParties.push(relyingParty);
                        }
                    }
                } catch (err) {
                    console.log(`Invalid relying party entry: ${relyingPartyLine}`);
                    console.error(err);
                }
            }
            this.props.save(importedRelyingParties);
            this.props.close();
        };
        fileReader.readAsText(this.state.selectedFile);
    };

    render() {
        return (
            <Modal
                id="importSilverfortConfigurationConfirm"
                dialogClassName="modal-md"
                show
                onHide={this.props.close}
                keyboard={false}
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{`Import Apps federated via ${RELYING_PARTIES_TYPES.ADFS.DISPLAY}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="content">
                        <div className="title">Select file to import:</div>
                        <div className="fileSelector">
                            <div className="filePath">
                                <span>{this.state.selectedFile ? this.state.selectedFile.name : ''}</span>
                            </div>
                            <div className="importButton">
                                <label htmlFor="configurationImport">
                                    <img src={importWhiteIcon} alt="" />
                                    Choose file
                                </label>
                                <input
                                    type="file"
                                    id="configurationImport"
                                    accept="application/text"
                                    multiple={false}
                                    disabled={this.state.loading}
                                    onChange={(e) => this.fileChangedHandler(e.target.files[0])}
                                />
                            </div>
                        </div>
                        {this.state.error && (
                            <div className="error">
                                <span>{this.state.error}</span>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button onClick={this.props.close}>Cancel</Button>
                        <Button
                            bsStyle={'danger'}
                            disabled={!this.state.selectedFile || this.state.loading}
                            onClick={this.importClickedHandler}>
                            Import
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ImportRelyingParties;
